import { Component, Input } from '@angular/core';
import { Insurance } from '@core/constants/data-types.constants';

@Component({
  selector: 'mfp-financial-health-feature-card',
  templateUrl: './financial-health-feature-card.component.html',
  styleUrls: ['./financial-health-feature-card.component.scss']
})
export class FinancialHealthFeatureCardComponent {
  @Input() insurance: Insurance | '' = '';
  @Input() title = '';
  @Input() value = 0;
  @Input() showIndicator = false;
  @Input() base = 0;
  @Input() current = 0;
  @Input() max = 0;
  @Input() newProducts = 0;

  constructor() {}
}
